module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"time-text":"Expira em","new-qr-code":"Criar novo QR Code"},"en-US":{"time-text":"Expires in","new-qr-code":"Create new QR Code"}}')
  delete Component.options._Ctor
}
